/* eslint-disable */
import { DataPrecaptureBankverbindungDto } from '../dto/data-precapture-bankverbindung-dto';
import { DataPrecaptureBerufsgenossenschaftDto } from '../dto/data-precapture-berufsgenossenschaft-dto';
import { DataPrecaptureFinanzamtDto } from '../dto/data-precapture-finanzamt-dto';
import { DataPrecaptureFirmaDto } from '../dto/data-precapture-firma-dto';
import { DataPrecaptureFormulareRechnungenDto } from '../dto/data-precapture-formulare-rechnungen-dto';
import { DataPrecaptureGeschaeftsstelleDto } from '../dto/data-precapture-geschaeftsstelle-dto';
import { DataPrecaptureWeiteresDto, fixDataPrecaptureWeiteresDtoFromJson, fixDataPrecaptureWeiteresDtoToJson } from '../dto/data-precapture-weiteres-dto';

export interface DataPrecaptureMandantDetailDto {
  id: number;
  firma: DataPrecaptureFirmaDto;
  finanzamt: DataPrecaptureFinanzamtDto;
  bankverbindung: DataPrecaptureBankverbindungDto[];
  berufsgenossenschaft: DataPrecaptureBerufsgenossenschaftDto;
  geschaeftsstelle: DataPrecaptureGeschaeftsstelleDto[];
  formulareRechnung: DataPrecaptureFormulareRechnungenDto;
  weiteres: DataPrecaptureWeiteresDto;
  isComplete: boolean;
}

export const fixDataPrecaptureMandantDetailDtoFromJson = (dto?: DataPrecaptureMandantDetailDto | null): void => {
  if (!dto) {
    return;
  }
  fixDataPrecaptureWeiteresDtoFromJson(dto.weiteres);
};

export const fixDataPrecaptureMandantDetailDtoToJson = (dto?: DataPrecaptureMandantDetailDto | null): void => {
  if (!dto) {
    return;
  }
  fixDataPrecaptureWeiteresDtoToJson(dto.weiteres);
};
